<template>
    <div class="empty-state">
        <div>
            <img
                :src="require('../../../../assets/img/empty-box.png')"
                alt
                class="empty-image"
            >
            <h3 class="empty-title">Nothing to show</h3>
        </div>
    </div>
</template>

<script>
export default {
    name: "EmptyViewComponent"
}
</script>

<style lang="scss" scoped>
    // empty state styles
    .empty-state{
        text-align: center;
        min-height: 500px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .empty-title{
        color: #f4f4f4;
        font-weight: bold;
        font-size: 24px;
    }
</style>


// WEBPACK FOOTER //
// src/components/pages/kitchen/ArnergyReportComponents/EmptyViewComponent.vue